import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css"; // Tailwind u otros estilos
import App from "./App"; // Importa el nuevo App.js
import { registerSessionInterceptor } from "./services/http/sessionInterceptor";

registerSessionInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
